var Backbone = require('backbone');
var _ = require('underscore');

require('./IndexSelect.less');


module.exports = Backbone.View.extend({

    el: '.IndexSelect',

    events: {
        'click .IndexSelect-item--member': 'onMemberClick',
        'click .IndexSelect-item--notmember': 'onNotMemberClick'
    },


    initialize: function () {
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    onMemberClick: function () {
        this.trigger('select', 'member');
    },


    onNotMemberClick: function () {
        this.trigger('select', 'notmember');
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/components/IndexSelect/IndexSelect.js
// module id = 20
// module chunks = 0